import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function ConfirmationInvitesModal({
    isOpen,
    onClose,
    onConfirm,
    loading = false
}) {

    return (
        <>

            <Modal isOpen={isOpen} toggle={loading ? undefined : onClose} centered>
                <ModalBody>
                    <div className='py-4 px-2'>
                        <h3 className='main_heading'>
                            Are you sure you want to {isOpen}?
                        </h3>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="main_button" disabled={loading} onClick={() => !loading && onConfirm(isOpen)}>
                        {loading ? 'Please wait...' : 'Yes'}
                    </button>
                    <button className="table_delete" disabled={loading} onClick={onClose}>Cancel</button>
                </ModalFooter>
            </Modal>


        </>
    );
}

export default ConfirmationInvitesModal;